import apiClient from '../../api/http-common';

const getAllMgaAttachments = (farmerId: string, data): any =>
  apiClient.post(`/farmers/${farmerId}/mga-attachments/index`, data);

const storeMgaAttachment = (farmerId: string, data): any =>
  apiClient.post(`/farmers/${farmerId}/mga-attachments/store`, data);

const deleteMgaAttachment = (farmerId: string, mgaAttachmentId: string): any =>
  apiClient.post(`/farmers/${farmerId}/mga-attachments/${mgaAttachmentId}/delete`);

const PREVIEW_URL = 'farmers/:farmerId/mga-attachments/:mgaAttachmentId/preview'

export const MGAAttachmentService = {
  getAllMgaAttachments,
  storeMgaAttachment,
  deleteMgaAttachment,
  PREVIEW_URL
}
